module.exports = __webpack_public_path__ + "img/vue2-semelle_vert.1bc56c79.png";